import Mock from 'mockjs'
Mock.mock('/getNew', 'get', require('../assets/news'))



// WEBPACK FOOTER //
// ./src/mock/mock.js